import { createContext, useContext, useState} from "react";
import { handleLogoutAccount } from "../utils/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    return JSON.parse(localStorage.getItem("user")) || null;
  });
  const [token, setToken] = useState(() => {
    return JSON.parse(localStorage.getItem("token")) || null;
  });

  const login = (userData) => {
    setUser(userData);
    setToken(userData?.token);
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", JSON.stringify(userData?.token));
  };

  const userSave = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = async () => {
    const response = await handleLogoutAccount();
    // console.log('response', response)

    setUser(null);
    setToken(null);
    localStorage.removeItem("showPlusActive");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  const isAuthenticated = !!user; // Convert user to boolean
  return (
    <AuthContext.Provider value={{ user, login, logout, userSave, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
